module.exports = __webpack_public_path__ + "static/media/UI_Select_Screen.6290949f.jpg";